import { Tooltip } from 'antd';

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/uielements/tooltip.js